import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-tree-item', {
  mixins: [eventListenerMixin],

  properties: {
    expandable: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: false,
      observer() {
        this.expandedChanged();
      },
    },

    selectable: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Boolean,
      default: false,
      observer() {
        this.selectedChanged();
      },
    },

    indeterminate: {
      type: Boolean,
      default: false,
      observer() {
        this.indeterminateChanged();
      },
    },

    depth: {
      type: Number,
      default: 0,
    },

    remote: {
      type: Object,
    },
  },

  expanding: false,

  connected() {
    this.toggleLink = this.querySelector('.link-toggle-item');
    this.list = this.querySelector('.tr-tree-list');

    this.listenTo(this.toggleLink, 'click', this.toggleExpanded.bind(this));
    this.listenTo(this.list, 'transitionend', this.afterListTransition.bind(this));

    this.initSelectable();
  },

  disconnected() {
    this.stopListening();
  },

  initSelectable() {
    if (this.selectable) {
      this.checkbox = this.querySelector('tr-checkbox-field');
      this.selectedChanged();

      this.listenTo(this.checkbox, 'tr-checkbox-field:change', (event) => {
        this.selected = event.detail.checked;
        this.namespacedTrigger('selectedChange', {
          detail: this.selected,
          bubbles: true,
        });
      });
    }
  },

  beforeExpandedChanged(expanded) {
    this.expanding = true;
    this.list.style.display = 'block';

    if (expanded) {
      this.list.style.height = 0;
    } else {
      this.list.style.height = `${this.list.scrollHeight}px`;
    }

    return this.offsetHeight;
  },

  expandedChanged() {
    if (this.expanded) {
      this.list.style.height = `${this.list.scrollHeight}px`;
    } else {
      this.list.style.height = 0;
    }
  },

  selectedChanged() {
    if (this.selectable) {
      this.checkbox.checked = this.selected;
    }
  },

  indeterminateChanged() {
    if (this.selectable) {
      this.checkbox.indeterminate = this.indeterminate;
    }
  },

  toggleExpanded() {
    this.beforeExpandedChanged(!this.expanded);
    this.expanded = !this.expanded;
  },

  afterListTransition() {
    if (!this.expanding) return;

    this.expanding = false;

    if (this.expanded) {
      this.list.style.height = 'auto';
      if (this.remote && this.list.querySelector('.tr-tree-loading')) {
        this.requestChildrenList();
      }
    } else {
      this.list.style.display = '';
    }
  },

  requestChildrenList() {
    $.ajax({
      url: this.remote.url,
      type: 'get',
      data: Object.assign({}, this.remote.params, {
        tree_item_id: this.taoId,
        depth: this.depth,
      }),
      dataType: 'script',
    });
  },

  updateList(newList) {
    if (this.expanding) this.afterListTransition();

    if (typeof newList === 'string') {
      const doc = new DOMParser().parseFromString(newList, 'text/html');
      this.list.parentNode.replaceChild(doc.body.firstChild, this.list);
    } else if (newList instanceof $) {
      this.list.parentNode.replaceChild(newList.get(0), this.list);
    } else {
      this.list.parentNode.replaceChild(newList, this.list);
    }

    this.list = this.querySelector('.tr-tree-list');
    this.listenTo(this.list, 'transitionend', this.afterListTransition.bind(this));
    this.namespacedTrigger('updateList', {
      detail: this.list,
      bubbles: true,
    });
  },
});
